module.exports = __webpack_public_path__ + "static/media/holly-mandarich-326680-unsplash.17694a6a.jpg";